import React, { useState } from 'react';
import { ExportButton, selectColumnsStore } from '@common/components';
import { gql, useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import Filters from 'works/legacy/lib/filters';

type ShiftsExportType = {
  createShiftsExport: {
    success: boolean;
  };
};

const GENERATE_CSV_EXPORT = gql`
  mutation createShiftsExport($input: CreateShiftsExportInput!) {
    createShiftsExport(input: $input) {
      success
    }
  }
`;

type Props = {
  disabled?: boolean;
};

export function ExportShiftsButton({ disabled = false }: Props) {
  const [timeoutActive, setTimeoutActive] = useState(false);
  const LOCALSTORAGE_KEY = 'ShiftRequestTableV2';

  const onCompleted = ({
    createShiftsExport: { success },
  }: ShiftsExportType) => {
    if (success) {
      createMessage(
        'success',
        "Your CSV Export is being generated. You'll receive an email with the final file when complete. Large exports may take a few minutes.",
        10
      );
      setTimeoutActive(true);
      setTimeout(() => setTimeoutActive(false), 5000);
    } else {
      createMessage('error', 'CSV Export failed. Please try again.');
    }
  };

  const [performExport, { loading }] = useMutation(GENERATE_CSV_EXPORT, {
    onCompleted: onCompleted,
    onError: () => {
      createMessage('error', 'CSV Export failed. Please try again.');
    },
  });

  const onClick = () => {
    performExport({
      variables: {
        input: {
          filters: Filters.getFilters(LOCALSTORAGE_KEY),
          columns: selectColumnsStore.get(LOCALSTORAGE_KEY),
        },
      },
    });
  };

  return (
    <ExportButton
      disabled={disabled || timeoutActive}
      onClick={onClick}
      loading={loading}
    >
      Export CSV
    </ExportButton>
  );
}
